import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DocumentsRoutingModule } from './documents-routing.module';
import { InstrumentFilterCheckboxesModule } from 'src/app/shared/instrument-filter-checkboxes/instrument-filter-checkboxes.module';
import { DocumentsComponent } from 'src/app/pages/user/documents/documents.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { PreloadSpinnerModule } from 'src/app/shared/preload-spinner/preload-spinner.module';
import { ButtonModule } from 'src/app/shared/button/button.module';
import { DocumentsDatePickerComponent } from 'src/app/shared/documents-date-picker/documents-date-picker.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { StringSearchbarModule } from 'src/app/shared/string-searchbar/string-searchbar.module';


@NgModule({
  declarations: [
    DocumentsComponent,
    DocumentsDatePickerComponent,
  ],
  imports: [
    CommonModule,
    DocumentsRoutingModule,
    InstrumentFilterCheckboxesModule,
    TranslateModule,
    PreloadSpinnerModule,
    AngularSvgIconModule,
    ButtonModule,
    NgxPaginationModule,
    StringSearchbarModule,
  ],
  exports: [
    DocumentsComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class DocumentsModule { }
